import React, { useContext, useEffect, useRef, useState } from 'react';
import styles from './SmartObject.module.scss';
import OptionPanel from './OptionPanel';
import CurrentContext from './CurrentContext';
import Viewer3d from './Viewer3d';
import { useLocation, useParams } from 'react-router-dom';
import ActionItems from './actionItems';
import useIsMobile from './utils/useIsMobile';
import { Loader } from 'semantic-ui-react';
import { isAndroid } from './utils/jsHelpers';
import ARViewerWrapper from './ArViewerWrapper';
import { AnimatedLoader } from '../Loader/ImagineLoader';

var isOpen = false;

const SmartObject_bullOutdoor = () => {
  const [grill, setGrill] = useState('30" Angus');
  const [siding, setSiding] = useState('Quartzite');
  const [door, setDoor] = useState('30" Double Door');
  const [secondDoor, setSecondDoor] = useState('Vertical Access Door');
  const [colorScheme, setcolorScheme] = useState('Sandstone Tan SR12');
  const [tileColorScheme, setTileColorScheme] = useState('Chocolate');
  const [iframeMessage, setIframeMessage] = useState('');
  const [isEditEnabled, setIsEditEnabled] = useState(false);
  const [isMeasure, setIsMeasure] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isARReady, setIsARReady] = useState(false);
  const [ARModelSrc, setARModelSrc] = useState(null);
  const [ARUnicode, setARUnicode] = useState(null);
  const [isAR, setIsAR] = useState(false);
  const [url, setUrl] = useState(null);
  const [apiLoading, setApiLoading] = useState(false);
  const [umbrellHole, setUmbrellHole] = useState(false);
  const [bottleOpener, setBottleOpener] = useState(false);
  const [sideBurner, setSideBurner] = useState(true);
  const [refrigerator, setRefrigerator] = useState(true);
  const [refrigeratorType, setRefrigeratorType] = useState('Standard Fridge');
  const [sink, setSink] = useState(true);
  const [animation, setAnimation] = useState(false);

  const [openModel, setOpenModel] = useState(false);
  const { modelId } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const sidebar = queryParams.get('hideSidebar');
  const useScroll = queryParams.get('scrollMode') === 'division';
  const _autoRotate = queryParams.get('autoRotate');
  const hideDragInfo = queryParams.get('hideDragInfo');
  const [autoRotate, setAutorotate] = useState(_autoRotate);
  const [showInfo, setShowInfo] = useState(useScroll);
  const [groutColor, setGroutColor] = useState({
    color: '#928272',
  });

  const propObject = {
    grill,
    setGrill,
    siding,
    setSiding,
    door,
    setDoor,
    secondDoor,
    setSecondDoor,
    refrigeratorType,
    setRefrigeratorType,
    sink,
    setSink,
    colorScheme,
    setcolorScheme,
    umbrellHole,
    setUmbrellHole,
    bottleOpener,
    setBottleOpener,
    sideBurner,
    setSideBurner,
    refrigerator,
    setRefrigerator,
    isEditEnabled,
    setIsEditEnabled,
    autoRotate,
    setAutorotate,
    isMeasure,
    setIsMeasure,
    loading,
    setLoading,
    isARReady,
    setIsARReady,
    ARModelSrc,
    setARModelSrc,
    ARUnicode,
    setARUnicode,
    isAR,
    setIsAR,
    apiLoading,
    setApiLoading,
    openModel,
    setOpenModel,
    openModel,
    setOpenModel,
    animation,
    setAnimation,
    tileColorScheme,
    setTileColorScheme,
    groutColor,
    setGroutColor,
  };

  useEffect(() => {
    const handleMessage = (event) => {
      const key = event.data.key
        ? event.data.key
        : event.data.type
        ? event.data.type
        : event.data.Type
        ? event.data.Type
        : event.data.Label
        ? event.data.Label
        : event.data.label;

      const value = event.data.value
        ? event.data.value
        : event.data.Value
        ? event.data.Value
        : event.data.Val
        ? event.data.Val
        : event.data.val
        ? event.data.val
        : event.data.texture
        ? event.data.texture
        : event.data.Texture;

      if (event.data !== iframeMessage) {
        switch (key) {
          case 'Grill':
            setGrill(value);
            if (
              (modelId === '3' || modelId === '2' || modelId === '5') &&
              grill !== '38" Brahma'
            ) {
              setDoor('30" Double Door');
            }
            break;
          case 'Countertop Tile':
            setTileColorScheme(value);
            break;
          case 'Base Material Options':
            setSiding(value);
            if (value === 'Quartzite') {
              setcolorScheme('Sandstone Tan SR12');
              // setRefrigerator(true);
            } else {
              setcolorScheme('Gray');
              // setRefrigerator(true);
              if (modelId === '1' || modelId === '3' || modelId === '4') {
                setRefrigeratorType('Standard Fridge');
              }
            }
            break;
          case 'Color':
            setcolorScheme(value);
            break;
          case 'color':
            setcolorScheme(value);
            break;
          case 'Door/Drawer':
            setDoor(value);
            break;
          case 'Second Door/Drawer':
            setSecondDoor(value);
            break;
          case 'Refrigeration Options':
            // const newValue = value === "Outdoor Rated Fridge"? "a":value
            setRefrigeratorType(value);
            break;
          case 'Umbrella hole':
            setUmbrellHole(value);
            break;
          case 'Bottle Opener':
            setBottleOpener(value);
            break;
          case 'Side Burner':
            setSideBurner(value);
            break;
          case 'Refrigerator':
            setRefrigerator(value);
            break;
          case 'Sink':
            setSink(value);
            break;
          default:
            break;
        }
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [iframeMessage]);

  const viewerWidth = () => {
    if (sidebar === 'true') {
      return '100%';
    }
    return window.innerWidth < 992 ? '100%' : '65%';
  };

  const viewerHeight = () => {
    if (window.innerWidth < 992) {
      return sidebar === 'true' ? '100vh' : '600px';
    }
    return sidebar === 'true' ? 'auto' : 'auto';
  };

  const optionPanelDisplay = sidebar === 'true' ? 'none' : 'block';

  const isMobile = useIsMobile();

  useEffect(() => {
    return () => {
      setApiLoading(false);
      setUrl(null);
      setLoading(false);
      setIsARReady(false);
      //   setIsAR(false);
      setARModelSrc(null);
      setARUnicode(null);
      isOpen = false;
    };
  }, []);

  useEffect(() => {
    if (!ARModelSrc) return;
    setUrl(ARModelSrc);
  }, [ARModelSrc]);

  return (
    <CurrentContext.Provider value={propObject}>
      <div id="visibleCanvasContainer" className={styles.mainContainer}>
        {useScroll && isMobile ? (
          <>
            {showInfo ? (
              <div
                className={styles.infoCanvas}
                onClick={() => setShowInfo(false)}
              >
                <div className={`${styles.area} ${styles.infoArea}`}>
                  <span>Use this area to interact with the product</span>
                </div>
                <div className={`${styles.area2} ${styles.infoArea}`}>
                  <span>Use this area to scroll the page</span>
                </div>
                <div className={styles.tapInfo}>Tap to begin</div>
              </div>
            ) : null}
            <div className={styles.scrollArea}></div>
          </>
        ) : null}

        <div
          className={styles.viewer3d}
          style={{
            width: viewerWidth(),
            height: viewerHeight(),
          }}
        >
          {loading ? <AnimatedLoader backDrop="transparent" /> : null}
          {!hideDragInfo ? (
            <div className={styles.infoTag}>Drag to rotate the product</div>
          ) : null}
          <Viewer3d />
          <ActionItems />
        </div>
        <div
          className={styles.optionPanel}
          style={{
            display: optionPanelDisplay,
            width: window.innerWidth < 992 ? '100%' : '35%',
          }}
        >
          <OptionPanel />
        </div>
        {/* {isMobile && url ? (
          <ModalViewerUI
            url={url}
            setUrl={setUrl}
            ARUnicode={ARUnicode}
            setLoading={setApiLoading}
          />
        ) : null} */}
      </div>
      {/* {openModel && (
        <div className={styles.arViewer}>
            {apiLoading ? <Loader/> : null}
            <ARViewerWrapper />
        </div>
      )} */}
    </CurrentContext.Provider>
  );
};

export default SmartObject_bullOutdoor;

const ModalViewerUI = ({
  url,
  setUrl,
  setLoading,
  setRef = null,
  ARUnicode,
}) => {
  // if (isAndroid() && ARUnicode && !isOpen) {
  //   isOpen = true;
  //   window.open(`${window.location.origin}/ar/preview/${ARUnicode}`, "_blank");
  //   return;
  // }
  return (
    <ModalViewer
      url={url}
      setUrl={setUrl}
      setLoading={setLoading}
      setRef={setRef}
    />
  );
};

export const ModalViewer = ({ url, setUrl, setLoading, setRef = null }) => {
  const btnRef = useRef();
  const modRef = useRef();
  const { setIsAR, setIsARReady } = useContext(CurrentContext);
  const [modelLoading, setModelLoading] = useState(true);

  const handleLoadModel = () => {
    setModelLoading(false);
    console.log('Model has finished loading.', url);
    if (url && btnRef.current) {
      btnRef?.current?.click?.();
      // console.log("Button Clicked 1");
      console.log('Button Clicked');
      setTimeout(() => {
        setLoading(false);
        //   setIsAR(false);
        // setARUnicode(null)
        // setARModelSrc(null)
        if (!isAndroid()) {
          setUrl(null);
          setIsARReady(false);
        }
      }, 5000);
    }
  };
  useEffect(() => {
    if (url && modRef?.current) {
      console.log('dEBUG___url', url);
      modRef?.current?.addEventListener('load', handleLoadModel);
    }
    return () => {
      modRef?.current?.removeEventListener('load', handleLoadModel);
    };
  }, [modRef?.current, url]);
  useEffect(() => {
    if (modRef?.current && setRef) setRef(modRef?.current);
  }, [modRef?.current, setRef]);
  if (!url) return;
  console.log('DEBUG___modalViewer');
  return (
    <>
      <AnimatedLoader />
      <model-viewer
        id="model-viewer"
        src={`${url}#canonicalWebPageURL=https://www.bullbbq.com`}
        alt="bullbbq"
        ar-modes="webxr quick-look scene-viewer"
        orientation={'0 0 0 1'}
        camera-controls
        ar
        ar-scale="auto"
        // poster={getCurrentProductThumbnail()}
        shadow-intensity="1"
        ref={modRef}
        // loading="eager"
        // loading="lazy"
        style={{
          width: 0,
          height: 0,
        }}
      >
        <button
          slot="ar-button"
          id="ar-button"
          ref={btnRef}
          style={{ width: '0', height: '0' }}
        ></button>
      </model-viewer>
    </>
  );
};
